import dotenvParseVariables from "dotenv-parse-variables";

const {
  VUE_APP_VENDOR,
  VUE_APP_API,
  VUE_APP_MCONNECT_ENV,
  VUE_APP_BLOB_STORAGE,
  VUE_APP_MY_PORTAL_URL,
  VUE_APP_EXTERNAL_AUTHENTICATION_PROVIDER_URL,
  VUE_APP_ENABLE_DEMO_MODE,
  VUE_APP_ENABLE_SPINDLE_SENSOR,
  VUE_APP_ENABLE_MACHINE_PRODUCTION_EVENTS,
  VUE_APP_ENABLE_ENERGY_METER,
  VUE_APP_FIREBASE_APIKEY,
  VUE_APP_FIREBASE_AUTHDOMAIN,
  VUE_APP_FIREBASE_PROJECTID,
  VUE_APP_FIREBASE_STORAGEBUCKET,
  VUE_APP_FIREBASE_MESSAGINGSENDERID,
  VUE_APP_FIREBASE_APPID,
  VUE_APP_VERSION,
  VUE_APP_ENABLE_SENTRY,
  VUE_APP_LOCALES,
  VUE_APP_MOBILE_GOOGLE_APP_URL,
  VUE_APP_MOBILE_APPLE_APP_URL,
  VUE_APP_MOBILE_APPLE_STORE_URL,
  VUE_APP_MOBILE_FALLBACK_URL,
  VUE_APP_ENABLE_GDOCS,
  VUE_APP_ENABLE_CONDITION_ANALYZER
} = dotenvParseVariables(process.env);

function getUrl() {
  return VUE_APP_API;
}

function getEnv() {
  return VUE_APP_MCONNECT_ENV || "dev";
}

// 4/11/2019 Old Storage files / Deprecated
function getImageUrl(path) {
  return `${VUE_APP_BLOB_STORAGE}${encodeURIComponent(path)}?alt=media`;
}
const vendor = VUE_APP_VENDOR;
const myPortalUrl = VUE_APP_MY_PORTAL_URL;
const externalAuthenticationProviderUrl = VUE_APP_EXTERNAL_AUTHENTICATION_PROVIDER_URL;
const enableDemoMode = VUE_APP_ENABLE_DEMO_MODE;
const enableSpindleSensor = VUE_APP_ENABLE_SPINDLE_SENSOR;
const enableMachineProductionEvents = VUE_APP_ENABLE_MACHINE_PRODUCTION_EVENTS;
const enableEnergyMeter = VUE_APP_ENABLE_ENERGY_METER;
const enableGDocs = VUE_APP_ENABLE_GDOCS;
const enableConditionAnalyzer = VUE_APP_ENABLE_CONDITION_ANALYZER;

const firebaseConfig = {
  apiKey: VUE_APP_FIREBASE_APIKEY,
  authDomain: VUE_APP_FIREBASE_AUTHDOMAIN,
  projectId: VUE_APP_FIREBASE_PROJECTID,
  storageBucket: VUE_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: VUE_APP_FIREBASE_MESSAGINGSENDERID,
  appId: VUE_APP_FIREBASE_APPID
};
const version = VUE_APP_VERSION === "undefined" ? undefined : VUE_APP_VERSION;
const enableSentry = !!VUE_APP_ENABLE_SENTRY;
const applicationLocales = VUE_APP_LOCALES;

const mobileGoogleAppUrl = VUE_APP_MOBILE_GOOGLE_APP_URL;
const mobileAppleAppUrl = VUE_APP_MOBILE_APPLE_APP_URL;
const mobileAppleStoreUrl = VUE_APP_MOBILE_APPLE_STORE_URL;
const mobileFallbackUrl = VUE_APP_MOBILE_FALLBACK_URL;

export {
  vendor,
  externalAuthenticationProviderUrl,
  enableDemoMode,
  enableGDocs,
  enableConditionAnalyzer,
  enableSpindleSensor,
  enableMachineProductionEvents,
  enableEnergyMeter,
  firebaseConfig,
  myPortalUrl,
  version,
  enableSentry,
  getEnv,
  getUrl,
  getImageUrl,
  applicationLocales,
  mobileGoogleAppUrl,
  mobileAppleAppUrl,
  mobileAppleStoreUrl,
  mobileFallbackUrl
};

export default getUrl;
